var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPdf2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6088",
    "data-name": "Group 6088",
    transform: "translate(4183 3303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6086",
    "data-name": "Group 6086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6084",
    "data-name": "Group 6084",
    transform: "translate(-4220 -3870)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6410",
    "data-name": "Rectangle 6410",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(37 567)",
    fill: "#82cecf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add_2_",
    "data-name": "add (2)",
    d: "M13.613,0H2.521A2.524,2.524,0,0,0,0,2.521v8.824a2.524,2.524,0,0,0,2.521,2.521H8.508a.63.63,0,0,0,.5-1.016L7.358,10.719l4.569-5.812,2.947,3.515V9.485a.63.63,0,1,0,1.261,0V2.521A2.524,2.524,0,0,0,13.613,0ZM12.395,3.5a.63.63,0,0,0-.978.015L6.563,9.691,4.91,7.556a.63.63,0,0,0-.5-.245h0a.63.63,0,0,0-.5.246L2.525,9.36a.63.63,0,0,0,1,.769l.889-1.156,2.811,3.632h-4.7a1.262,1.262,0,0,1-1.261-1.261V2.521A1.262,1.262,0,0,1,2.521,1.261H13.613a1.262,1.262,0,0,1,1.261,1.261V6.46ZM4.412,2.269A1.891,1.891,0,1,0,6.3,4.16,1.893,1.893,0,0,0,4.412,2.269Zm0,2.521a.63.63,0,1,1,.63-.63A.631.631,0,0,1,4.412,4.79Zm11.723,7.216a.63.63,0,0,1-.63.63H13.771V14.37a.63.63,0,0,1-1.261,0V12.637H10.777a.63.63,0,1,1,0-1.261h1.733V9.643a.63.63,0,1,1,1.261,0v1.733H15.5A.63.63,0,0,1,16.134,12.006Zm0,0",
    transform: "translate(49 580)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6085",
    "data-name": "Group 6085",
    transform: "translate(48 -44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78056",
    "data-name": "Path 78056",
    d: "M.848.807A2.805,2.805,0,0,0,.067,2.757V24.813a2.805,2.805,0,0,0,.781,1.949,2.622,2.622,0,0,0,1.885.807H20.507a2.623,2.623,0,0,0,1.885-.807,2.806,2.806,0,0,0,.781-1.949V6.052L17.32,0H2.733A2.622,2.622,0,0,0,.848.807Z",
    transform: "translate(-4221.12 -3253.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78057",
    "data-name": "Path 78057",
    d: "M9.269,30.6H8.2V28.467H9.269a1.069,1.069,0,1,1,0,2.137Z",
    transform: "translate(-4227.057 -3269.504)",
    fill: "#92ccce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78058",
    "data-name": "Path 78058",
    d: "M24.467,34.879V28.467h1.069A1.069,1.069,0,0,1,26.6,29.535V33.81a1.069,1.069,0,0,1-1.069,1.069Z",
    transform: "translate(-4235.036 -3269.504)",
    fill: "#82cecf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78059",
    "data-name": "Path 78059",
    d: "M.067,3.206A3.254,3.254,0,0,1,.979.939,3.071,3.071,0,0,1,3.182,0H20.228l6.839,7.039V28.856a3.255,3.255,0,0,1-.912,2.267,3.072,3.072,0,0,1-2.2.939H3.182a3.071,3.071,0,0,1-2.2-.939,3.254,3.254,0,0,1-.912-2.267Zm5.192,9.619H2.144V23.512H4.221V19.237H5.259a3.072,3.072,0,0,0,2.2-.939,3.273,3.273,0,0,0,0-4.534A3.072,3.072,0,0,0,5.259,12.825Zm8.308,0H10.451V23.512h3.115a3.071,3.071,0,0,0,2.2-.939,3.254,3.254,0,0,0,.913-2.267V16.031a3.254,3.254,0,0,0-.913-2.267A3.071,3.071,0,0,0,13.567,12.825Zm5.192,10.687V12.825H24.99v2.138H20.836V17.1h2.077v2.138H20.836v4.275Z",
    transform: "translate(-4223.067 -3256)",
    fill: "#82cecf",
    fillRule: "evenodd"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdf2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf2.469ffd79.svg";
export { ForwardRef as ReactComponent };